module.exports = __webpack_public_path__ + "static/map-marker-79b0573faca8c4dfc6265a8d9abf15a2.png";